export const ProductTypesEnum = {
  P13: 4,
  P45: 5,
  P13Completo: 6
}
